import React, { FC } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment/moment';

import { fc } from 'i18n';
import { IMultipleEditForm } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';

import styles from './styles.module.css';

interface ICellProps {
  rowIndex: number;
}

export const Since: FC<ICellProps> = ({ rowIndex }) => {
  const { formState, control } = useFormContext<IMultipleEditForm>();

  const endOn: Date | undefined = useWatch({ control, name: `leases.${rowIndex}.endOn` });

  const error = formState.errors.leases?.[rowIndex]?.startOn?.message;

  const disabledDate = (date: Date) => {
    const isBeforeToday = moment(date).isBefore(moment(new Date()), 'day');

    return endOn ? isBeforeToday || moment(date).isAfter(moment(endOn), 'day') : isBeforeToday;
  };

  return (
    <Controller
      control={control}
      name={`leases.${rowIndex}.startOn`}
      rules={{ required: fc('please select start date') }}
      render={({ value, onChange }) => (
        <div className={styles.datePicker}>
          <DatePicker
            placeholder={fc('start date')}
            value={value ? new Date(value) : null}
            onChange={onChange}
            disabledDate={disabledDate}
          />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  );
};
